import axios from 'axios';
import { IDKitResult } from '@worldcoin/idkit';
import CONSTANTS from '../contants';
import { worldIdApiUrl } from '../app.config';

const worldIdApi = axios.create({
  baseURL: worldIdApiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

worldIdApi.interceptors.request.use(config => {
  const token = localStorage.getItem(CONSTANTS.token);
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
});

export const getWorldIdRpContext = (data: { app_id: string; action: string }) =>
  worldIdApi.post<{
    app_id: string;
    action: string;
    rp_context: {
      rp_id: `rp_${string}`;
      nonce: string;
      created_at: number;
      expires_at: number;
      signature: string;
    };
  }>('/v2/world-id/rp-context', data);

export const WORLD_ID_CONFIG = {
  app_id: 'app_b871efd435c0498e8d5aaf2517a54185' as const,
  action: 'proof-of-human',
};

export const verifyWorldId = (data: {
  proof: IDKitResult;
  app_id: string;
  action: string;
  signal: string;
  rp_id?: string;
}) =>
  worldIdApi.post<{
    success: boolean;
    already_verified: boolean;
    nullifier: string;
    action: string;
    environment: string;
    created_at: string;
  }>('/v2/world-id/verify', data);
